document.addEventListener('DOMContentLoaded', function () {
  const recommendSwiper = new Swiper('.recommendSwiper', {
    loop: false,
    watchOverflow: true,
    slidesPerView: 2, 
    spaceBetween: 8,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // 600: {
      //   slidesPerView: 1.8,
      //   spaceBetween: 12,
      // },
      // 768: {
      //   slidesPerView: 2,
      //   spaceBetween: 16,
      // },
      1024: {
        slidesPerView: 3.2,
        spaceBetween: 16,
      },
      1400: {
        slidesPerView: 4,
        spaceBetween: 24,
      }
    }
  });
});



document.addEventListener('DOMContentLoaded', function () {
  const thoughtSwiper = new Swiper('.thought-swiper', {
    loop: true,
    slidesPerView: 'auto',       
    spaceBetween: 30,
    speed: 5000,        
    slidesPerView: 5,         
    freeMode: true,              
    autoplay: {
      delay: 0,                  
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    allowTouchMove: false,       
  });
});

let flowPurchaseSwiper = null;

function initFlowPurchaseSwiper() {
  const windowWidth = window.innerWidth;

  if (windowWidth < 1024) {
    let slides;

    if (windowWidth <= 500) {
      slides = 1.5;
    } else if (windowWidth < 768) {
      slides = 2;
    } else {
      slides = 3;
    }

    if (!flowPurchaseSwiper) {
      flowPurchaseSwiper = new Swiper('.flowPurchaseSwiper', {
        slidesPerView: slides,
        spaceBetween: 16,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    } else {
      // すでに初期化済みなら、slidesPerView だけ更新（リサイズ対応用）
      flowPurchaseSwiper.params.slidesPerView = slides;
      flowPurchaseSwiper.update();
    }

  } else {
    // 1024px以上はSwiperを破棄
    if (flowPurchaseSwiper) {
      flowPurchaseSwiper.destroy(true, true);
      flowPurchaseSwiper = null;
    }
  }
}

// 初回読み込み時
document.addEventListener('DOMContentLoaded', initFlowPurchaseSwiper);

// リサイズ時にも対応
window.addEventListener('resize', initFlowPurchaseSwiper);








